import PropTypes from "prop-types";

import colors from "assets/theme/base/colors";

function Dashboard({ color, size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
      <g id="Basic-Elements" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          fill={colors[color] ? colors[color].main : colors.dark.main}
          fillRule="nonzero"
          d="M.0003 320C.0003 160.9 128.9 32 288 32C447.1 32 576 160.9 576 320C576 370 563.2 417.1 540.8 458.1C533.1 472.1 517.9 480 501.9 480H74.13C58.11 480 42.9 472.1 35.21 458.1C12.76 417.1 0 370 0 320H.0003zM256 128C256 145.7 270.3 160 288 160C305.7 160 320 145.7 320 128C320 110.3 305.7 96 288 96C270.3 96 256 110.3 256 128zM128 320C128 302.3 113.7 288 96 288C78.33 288 64 302.3 64 320C64 337.7 78.33 352 96 352C113.7 352 128 337.7 128 320zM448 320C448 337.7 462.3 352 480 352C497.7 352 512 337.7 512 320C512 302.3 497.7 288 480 288C462.3 288 448 302.3 448 320zM192 192C192 174.3 177.7 160 160 160C142.3 160 128 174.3 128 192C128 209.7 142.3 224 160 224C177.7 224 192 209.7 192 192zM343.4 416C348.9 406.6 352 395.7 352 384C352 370.6 347.9 358.2 340.9 347.9L435.1 205.3C443.3 194.3 440.3 179.4 429.3 172C418.3 164.7 403.4 167.7 396 178.7L300.9 321.3C296.8 320.5 292.4 320 288 320C252.7 320 224 348.7 224 384C224 395.7 227.1 406.6 232.6 416H343.4z"
        />
      </g>
    </svg>
  );
}

Dashboard.defaultProps = {
  color: "dark",
  size: "16px",
};

Dashboard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Dashboard;
